import { CircularProgress } from "@mui/material";

export const CenteredLoading: React.FC = () => (
  <div style={{ textAlign: "center", marginTop: "50px" }}>
    <CircularProgress />
  </div>
);
